import PropTypes from "prop-types";
import React from "react";

import { OUT_OF_NETWORK_INSURANCE_OPTION, UNINSURED_OPTION } from "@/core/constants/insurance";

import { Image } from "../../Image";
import { Link } from "../../Link";
import { Popup } from "../../Popup";
import { SUPPORT_NUMBER, SUPPORT_NUMBER_HREF } from "../../../constants/aptihealth";
import { trackEvent } from "../../../utils/EventTrackingUtil";

import "./styles.scss";

const supportPhoneNumberLink = (
  <a className="support-link" href={SUPPORT_NUMBER_HREF}>
    {SUPPORT_NUMBER}
  </a>
);
const supportEmail = "support@aptihealth.com";
const supportEmailLink = (
  <a className="support-link" href={`mailto: ${supportEmail}?subject=Web Support Request`}>
    {supportEmail}
  </a>
);
const footer = (
  <>
    If you have any questions please contact
    <br />
    {supportPhoneNumberLink} or {supportEmailLink}
  </>
);

const acknowledgementText = {
  [OUT_OF_NETWORK_INSURANCE_OPTION]: {
    subtitle: (eventPrefix) => (
      <>
        The insurance company may be out-of-network. You will be responsible for any associated
        fees. Learn about&nbsp;
        <Link
          href="/session-pricing"
          onClick={() => trackEvent(`${eventPrefix}-insurance-not-listed-modal-click-rates`)}
        >
          aptihealth's rates <Image src="open-in-tab.svg" />
        </Link>
      </>
    ),
    title: "Can’t find the insurance you are looking for?",
  },
  [UNINSURED_OPTION]: {
    subtitle: (eventPrefix) => (
      <>
        You will be responsible for any associated fees. Learn about&nbsp;
        <Link
          href="/session-pricing"
          onClick={() => trackEvent(`${eventPrefix}-no-insurance-modal-click-rates`)}
        >
          aptihealth's rates <Image src="open-in-tab.svg" />
        </Link>
      </>
    ),
    title: "Don’t have health insurance?",
  },
};

export const InsuranceAcknowledgementPopupHOC = ({
  acknowledgementType,
  className,
  disabled,
  gaEventPrefix,
  primaryOnClick,
  secondaryOnClick,
  ...props
}) => {
  return (
    <Popup
      className={className}
      disabled={disabled}
      footer={footer}
      primaryOnClick={primaryOnClick}
      primaryText="Acknowledge"
      secondaryOnClick={secondaryOnClick}
      secondaryText="Return to Insurance"
      subtitle={acknowledgementText[acknowledgementType].subtitle(gaEventPrefix)}
      title={acknowledgementText[acknowledgementType].title}
      {...props}
    />
  );
};

InsuranceAcknowledgementPopupHOC.propTypes = {
  acknowledgementType: PropTypes.oneOf([UNINSURED_OPTION, OUT_OF_NETWORK_INSURANCE_OPTION])
    .isRequired,
  primaryOnClick: PropTypes.func.isRequired,
};
